var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"defined-term",class:{ tooltip: !!_vm.definition },attrs:{"data-tooltip":_vm.definition}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }